import bellIcon from "../../assets/icons/bell.svg";

const UnseenPill = ({ count, label = "unseen", icon = bellIcon, modifier }) => {
    const value = Number(count) || 0;
    if (value <= 0) return null;

    return (
        <span className={`unseen-pill${modifier ? ` unseen-pill--${modifier}` : ""}`} title={`${value} ${label}`}>
            <img src={icon} alt="" className="unseen-pill__icon" />
            <span className="unseen-pill__count">{value}</span>
        </span>
    );
};

export default UnseenPill;
